import { useBackInStockModalContext } from 'back-in-stock/src/hooks/useBackInStockModalContext/useBackInStockModalContext'
import type { BackInStockProps } from 'back-in-stock/src/types'
import { SELECTED_SIZE_ID_KEY } from 'product/constants/constants'
import { env } from 'utils/envManager'
import { removeFromSessionStorage } from 'utils/webStorage/sessionStorage'

import { useColors } from '../../../../contexts/ColorsProvider/ColorsProvider'
import { useProduct } from '../../../../contexts/ProductProvider/ProductProvider'
import { useSizes } from '../../../../contexts/SizesProvider/SizesProvider'
import type { Size } from '../../../../types/FullProduct'

interface UseSizeItemClickProps {
	isUnselectable: boolean
	withSheet: boolean
}

export function useSizeItemClick({
	isUnselectable,
	withSheet,
}: UseSizeItemClickProps): (size: Size) => void {
	const { openProductSubscription } = useBackInStockModalContext()
	const { product } = useProduct()
	const { selectedColor } = useColors()

	const { select, isSheetOpen, openSheet, setHasErrorMessage } = useSizes()

	const handleUnselectableSize = (): void => {
		select(undefined)
		removeFromSessionStorage(SELECTED_SIZE_ID_KEY)
	}

	const handleNotAvailable = (size: Size): void => {
		const backInStockprops: BackInStockProps = {
			productId: product.id,
			productName: product.name,
			productColorId: selectedColor.id,
			productSizeId: size.id,
			feedbackDelay: 0,
		}
		openSheet(false)
		openProductSubscription(backInStockprops)
	}

	const handleAvailable = (size: Size): void => {
		select(size)
		setHasErrorMessage(false)

		if (size.relatedProductUrl) {
			const productUrl = new URL(
				size.relatedProductUrl,
				env.NEXT_PUBLIC_SITE_BASE_URL
			)

			window.location.assign(productUrl.pathname + productUrl.search)
		}

		if (withSheet) {
			openSheet(!isSheetOpen)
		}
	}

	return (size: Size): void => {
		if (isUnselectable) {
			handleUnselectableSize()
		} else if (!size.available) {
			handleNotAvailable(size)
		} else {
			handleAvailable(size)
		}
	}
}
